import { render, staticRenderFns } from "./TenantInvoiceRecords.vue?vue&type=template&id=3f3b2dfe&scoped=true"
import script from "./TenantInvoiceRecords.vue?vue&type=script&lang=js"
export * from "./TenantInvoiceRecords.vue?vue&type=script&lang=js"
import style0 from "./TenantInvoiceRecords.vue?vue&type=style&index=0&id=3f3b2dfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3b2dfe",
  null
  
)

export default component.exports